export default "__VITE_ASSET__L9Q_x4f1__"